import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postFavoriteAddress} from '../services/postFavoriteAddress';
import {PostFavoriteAddressServiceParams} from '../types';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';

export function usePostFavoriteAddressMutation() {
	const queryClient = useQueryClient();
	const beneficiaryCode = useAccountDataStore(state => state.accountData.beneficiary.cdUsuarioC);

	return useMutation({
		mutationFn: ({data, signal}: PostFavoriteAddressServiceParams) =>
			postFavoriteAddress({data, signal}),
		onSuccess: () => {
			queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROFILE_FAVORITE_ADDRESSES]});
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.ADDRESS_UPDATE_INDICATOR, beneficiaryCode],
			});
		},
	});
}
